/* eslint-disable max-len */
import React from 'react';

const YandexButtonIcon: React.FC<object> = () => {

    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 16C0 7.1632 7.1616 0 16 0C24.8352 0 32 7.1632 32 16C32 24.8368 24.8352 32 16 32C7.1616 32 0 24.8368 0 16Z" fill="#F8604A"/>
            <path d="M18.0526 9.06667H16.5742C13.8638 9.06667 12.4382 10.4395 12.4382 12.4635C12.4382 14.7515 13.4238 15.8235 15.4478 17.1979L17.1198 18.3243L12.315 25.5035H8.72461L13.0366 19.0811C10.5566 17.3035 9.16461 15.5771 9.16461 12.6571C9.16461 8.99627 11.7166 6.49707 16.5566 6.49707H21.3614V25.4859H18.0526V9.06667Z" fill="white"/>
        </svg>
    );
};

export default YandexButtonIcon;
    